import React, { HTMLAttributes } from 'react'

import { AddEmployerCard } from '../add-employer/add-employer-card'
import { AddEmployerButton } from './add-employer-button'

type Props = {
  onClick?: () => void
  className?: HTMLAttributes<HTMLDivElement>['className']
  isTaskListEmpty?: boolean
}

export function AddEmployer({ onClick, isTaskListEmpty = false, className }: Props) {
  if (!isTaskListEmpty) {
    return <AddEmployerButton onClick={onClick} className={className} />
  }

  return <AddEmployerCard onClick={onClick} className={className} />
}
